import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function AuthLoading() {
  return <div className="page-stack"><div className="section">Restoring session…</div></div>;
}

export function RequireAuth({ children }) {
  const { user, initializing } = useAuth();
  const loc = useLocation();

  if (initializing) return <AuthLoading />;
  if (!user) return <Navigate to="/login" replace state={{ from: loc }} />;

  if (user.mustChange && loc.pathname !== "/force-password") {
    return <Navigate to="/force-password" replace />;
  }
  return children;
}

export function RequireRole({ roles, children }) {
  const { user, initializing } = useAuth();
  if (initializing) return <AuthLoading />;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.currentRole)) return <Navigate to="/" replace />;
  return children;
}
